var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('providers',{attrs:{"album-i-d":_vm.album.album_id,"write-permission":_vm.album.is_admin}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }